import {connect} from 'react-redux'
import {
  discountsPageRequest,
  changeDateDiscounts,
  changeOutletDiscounts,
  exportDiscount
} from 'actions/reports/sales'
import SidebarReports from 'components/SidebarReports'
import styles from './Discounts.css'
import NoDataDisplay from 'components/NoDataDisplay/NoDataDisplay'
import moment from 'moment'
import {formValueSelector} from 'redux-form'
import ActionBar from '../ActionBar'
import LoadingSpinner from 'components/LoadingSpinner'
import TableScrollHorizontalVertical from 'components/TableScrollHorizontalVertical'
import {rupiahWithNegative, currencyFormatterWithoutFloat} from 'utils/formatter'
import TableWithoutChild from 'components/TableReportSales/TableWithoutChild'
import {browserHistory} from 'react-router'
import * as mpDiscounts from 'mixpanel/reports/discounts'

class Discounts extends React.Component {
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    if (!expired) {
      this.props.dispatch(discountsPageRequest())
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  constructor (props) {
    super(props)
    this.state = {
      openSidebar: false
    }
  }

  render () {
    let {discounts, showLoadingSpinnerReport} = this.props.data.reports.discounts
    let [parentBody, childBody, childFoot] = this._formatDataForList(discounts)
    let [childFootResponsive, childBodyResponsive] = this._formatDataForListResponsive(discounts)

    return (
      <div id='reports-sales-discounts' className={styles.wrapper}>
        <ActionBar onChangeDate={this._onChangeDate} onChangeOutlet={this._onChangeOutlet} onExport={this._onClickExport} />
        <div className='mk-report-sales full-height'>
          <div className='row full-height'>
            <SidebarReports elementClass='visible-lg visible-md slideMenuWeb' location={this.props.location} />
            <SidebarReports elementClass={'visible-xs visible-sm slideMenuMobile ' + (this.state.openSidebar ? 'slideMenuMobileSlide' : '')} onToggle={this._toogleSidebar} location={this.props.location} />
            <div className='col-xs-12 col-sm-12 col-md-9 col-lg-9 report-right-menu full-height'>
              <div className='mk-report-sales-content full-height'>
                <div className='mk-burger-box visible-xs visible-sm'>
                  <div className='mk-burger'>
                    <button type='button' className='navbar-toggle collapsed navbar-burger' onClick={this._showSidebar} data-toggle='collapse' >
                      <span className='sr-only'>Toggle navigation</span>
                      <span className='icon-bar' />
                      <span className='icon-bar' />
                      <span className='icon-bar' />
                    </button>
                  </div>
                </div>
                <div className={styles.tableWrapper + ' discount-sales-table visible-md visible-lg'}>
                  <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
                  {discounts.length > 0 && <TableScrollHorizontalVertical
                    parentHeader={'Name'}
                    parentBody={parentBody}
                    parentFoot={'Total'}
                    parentClassName={['p-header', 'p-body', 'p-foot']}
                    childHeaders={['Discount Amount', 'Count', 'Gross Discount', 'Discount Refunded', 'Net Discount']}
                    childBody={childBody}
                    childFoot={childFoot}
                    childHeaderClassName={['header-discount-amount', 'header-count', 'header-gross-discount', 'header-discount-refunded', 'header-net-discount']}
                    childBodyClassName={['body-discount-amount', 'body-count', 'body-gross-discount', 'body-discount-refunded', 'body-net-discount']}
                    childFootClassName={['foot-discount-amount', 'foot-count', 'foot-gross-discount', 'foot-discount-refunded', 'foot-net-discount']}
                    />}
                  {!discounts.length && !showLoadingSpinnerReport &&
                    <div className='no-data-display-container'>
                      <NoDataDisplay title='No Data to Display' />
                    </div>}
                </div>
                <div className={styles.tableWrapperResponsive + ' visible-xs visible-sm'}>
                  <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
                  {discounts.length > 0 && <TableWithoutChild
                    headerBody={['Name', 'Discount Amount', 'Count']}
                    childBody={childBodyResponsive}
                    footBody={childFootResponsive}
                    tableClass='discount-sales-table-responsive'
                    headerBodyClassName={['header-name', 'header-discount-amount', 'header-count']}
                    childBodyClassName={['body-name', 'body-discount-amount', 'body-count']}
                    footBodyClassName={['foot-name', 'foot-discount-amount', 'foot-count']} />}
                  {!discounts.length && !showLoadingSpinnerReport &&
                    <div className='no-data-display-container'>
                      <NoDataDisplay title='No Data to Display' />
                    </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _formatDataForList = (discounts) => {
    let parentBody = []
    let childBody = []
    let childFoot = {
      total_discount_amount: null,
      total_count: null,
      total_discount_applied: null,
      total_discount_refunded: null,
      total_net_discount: null
    }
    discounts.map(function (discount) {
      parentBody.push(discount.name)
      childBody.push({
        amount: discount.discount_type === 'cash' ? `Rp. ${Math.round(discount.amount)}` : `${discount.amount}%`,
        count: discount.count,
        discount_applied: rupiahWithNegative(-discount.discount_applied),
        refund: currencyFormatterWithoutFloat(discount.refund),
        net_discount: rupiahWithNegative(-discount.net_discount)
      })
      childFoot.total_count = childFoot.total_count + discount.count
      childFoot.total_discount_applied = childFoot.total_discount_applied + Math.round(discount.discount_applied)
      childFoot.total_discount_refunded = childFoot.total_discount_refunded + Math.round(discount.refund)
      childFoot.total_net_discount = childFoot.total_net_discount + Math.round(discount.net_discount)
    })

    childFoot.total_count = childFoot.total_count
    childFoot.total_discount_applied = rupiahWithNegative(-childFoot.total_discount_applied)
    childFoot.total_discount_refunded = childFoot.total_discount_refunded === 0 ? null : rupiahWithNegative(childFoot.total_discount_refunded)
    childFoot.total_net_discount = childFoot.total_net_discount === 0 ? null : rupiahWithNegative(-childFoot.total_net_discount)

    return [parentBody, childBody, childFoot]
  }

  _formatDataForListResponsive = (discounts) => {
    let childBody = []
    let footBody = {
      name: 'Total',
      total_discount_amount: null,
      total_discount_count: null
    }
    if (discounts) {
      discounts.map(function (discount) {
        childBody.push({
          name: discount.name,
          amount: discount.discount_type === 'cash' ? `Rp. ${Math.round(discount.amount)}` : `${discount.amount}%`,
          count: discount.count
        })
        footBody.total_discount_count = footBody.total_discount_count + discount.count
      })
    }
    return [footBody, childBody]
  }

  _onChangeOutlet = (outletIds = []) => {
    let {startDate, endDate} = this.props.search.date
    mpDiscounts.reportsDiscountChangeFilter({
      outletIds,
      startDate,
      endDate
    })
    this.props.dispatch(changeOutletDiscounts({outletIds, startDate, endDate}))
  }

  _showSidebar = () => {
    this.setState({openSidebar: !this.state.openSidebar})
  }
  _toogleSidebar = () => {
    this.setState({openSidebar: !this.state.openSidebar})
  }

  _onChangeDate = ({startDate, endDate}) => {
    const {outlet} = this.props.search
    mpDiscounts.reportsDiscountChangeFilter({
      outletIds: outlet,
      startDate,
      endDate
    })
    let outletIds = this.props.search.outlet.join(',')
    this.props.dispatch(changeDateDiscounts(startDate.toDate(), endDate.toDate(), outletIds))
  }

  _onClickExport = () => {
    let {startDate, endDate} = this.props.search.date
    const outlet = this.props.search.outlet
    mpDiscounts.reportsDiscountExport({
      outletIds: outlet,
      startDate,
      endDate
    })
    let query = {start: moment(startDate).format('D/M/Y'), end: moment(endDate).format('D/M/Y'), outletIds: outlet.join(',')}
    let dateLabel = startDate.isSame(endDate, 'days') ? moment(startDate).format('DD-MM-YYYY') : [moment(startDate).format('DD-MM-YYYY'), moment(endDate).format('DD-MM-YYYY')].join(' - ')
    let outletName = outlet.length > 1 ? 'All Outlets' : this.props.data.reports.discounts.outlets.find(e => e.id === outlet[0]).name
    let filename = `Report Discounts -   ${dateLabel} - ${outletName}`
    this.props.dispatch(exportDiscount(query, filename))
  }
}

const selector = formValueSelector('search')

function select (state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        discounts: state.reports.discounts
      },
      subscriptionExpired: state.subscriptionExpired
    }
  }
}

export default connect(select)(Discounts)



// WEBPACK FOOTER //
// ./app/pages/Reports/Sales/Discounts/Discounts.js